module.exports = ".mat-radio-button {\r\n    display: block;\r\n}\r\n.mat-radio-outer-circle{\r\n    background: #FFF;\r\n}\r\nh5 i{\r\n  color:rgb(16, 54, 180);  \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/b-radio/b-radio.component.css
// module id = ./src/app/parts/b-radio/b-radio.component.css
// module chunks = main